import { isObject } from "@helpers/utils.js"
import { nextTick } from "vue"

import model from "../model.js";
import controller from "../controller/controller.js";

export default function(){
	var fitTexts = [];
	
	model.on('WindowResize', 'ForceResize', () => {
		fitTexts.forEach(props => {
			// if the font-size value is zero, then the 
			// element is not visible to begin with
			if(Number(getComputedStyle(props.elem).fontSize.replace(/[^0-9.]/g, '')) > 0) fitText(props.elem, props.fitText);
		});
	});
	
	function beforeMount(element, binding){
		var props = binding.value;
		var elem = element;
	
		if(!Boolean(props)) return;
	
		if(isObject(props.onClick) && props.onClick.selector && typeof props.onClick.callback === 'function'){
			nextTick(() => {
				const target = elem.querySelector(props.onClick.selector);
				if (target) target.addEventListener('click', props.onClick.callback);
			});
		}
	
		if(props.fitText){
			props.fitText = typeof props.fitText === 'boolean' ? {} : props.fitText;
	
			if(typeof props.fitText.parentSelector === 'string'){
				var parent = elem.closest(props.fitText.parentSelector);
				if(parent)
					props.fitText.parent = parent;
			}
	
			props.fitText = Object.assign({
				maxSize: 14,
			}, props.fitText);
	
			fitTexts.push({
				elem: elem,
				fitText: props.fitText,
			});
	
			if(props.fitText.parent){
				props.fitText.parent.updateFitText = function(){
					fitText(elem, props.fitText);
				};
			}
	
			elem.dataset.langFitText = true;
		}
	
		updated(element, binding);
	}
	
	function areValuesTheSame(value, oldValue){
		let fitTextParent;
		let oldFitTextParent;
	
		if(value?.fitText?.parent) {
			fitTextParent = value.fitText.parent;
			value.fitText.parent = null;
		}
	
		if(oldValue?.fitText?.parent) {
			oldFitTextParent = oldValue.fitText.parent;
			oldValue.fitText.parent = null;
		}
	
		let bool = fitTextParent === oldFitTextParent && JSON.stringify(value) === JSON.stringify(oldValue);
	
		isObject(value?.fitText) && (value.fitText.parent = fitTextParent);
		isObject(oldValue?.fitText) && (oldValue.fitText.parent = oldFitTextParent);
		
		return bool;
	}
	
	function updated(element, binding){
		var props = binding.value;
		var elem = element;
	
		if(areValuesTheSame(binding.value, binding.oldValue)) return;
		
		if(!Boolean(props)) {
			elem.setAttribute('placeholder', '');
			return;
		}
	
		var fitTextProps = fitTexts.find(ft => ft.elem === element);
		if(isObject(fitTextProps)) fitTextProps = fitTextProps.fitText;
	
		element.langDisposeCallback?.();
		element.langDirectiveCallback = model.on('SetLang', () => {
			if(typeof props === 'string')
				insertText(elem, model.getStr(props, null, true));
			else if(typeof props === 'object' && props !== null){
				var text = props.text || '';
				if(typeof props.label === 'string') text = model.getStr(props.label, null, true);
				else if(isObject(props.label)) text = model.redeemLangObj(props.label);
	
				var placeholders = props.placeholders;
				if(typeof placeholders === 'object' && placeholders !== null){
					for(var key in placeholders){
						var val = placeholders[key];
	
						var indOpen = 0;
						var indClose = 0;
						var langKey = null;
	
						if(typeof val === 'string' && val){
							while(true){
								indOpen = val.indexOf('{');
								indClose = val.indexOf('}');
								if(indOpen === -1 || indClose === -1)
									break;
	
								langKey = val.substring(indOpen + 1, indClose);
								val = val.replace(new RegExp('\\{' + langKey + '\\}', 'g'), model.getStr(langKey));
							}
						}
	
						text = (text+'').replace(new RegExp('\\{' + key + '\\}', 'g'), val);
					}
				}
				
				insertText(elem, text);
			}
	
			fitText(elem, fitTextProps);
		});
	
		element.langDirectiveCallback();
	
		element.langDisposeCallback = () => {
			model.off('SetLang', element.langDirectiveCallback);
			fitTexts.includes(fitTextProps) && fitTexts.splice(fitTexts.indexOf(fitTextProps), 1);
		};
	}
	
	function insertText(elem, text){
		if(elem.dataset.langFitText) {
			elem.innerHTML = `<div><span>${text}</span><span class="shown">${text}</span></div>`;
		} else {
			controller.langHandler.setLangToNodes(elem, text);
		}
	}
	
	function fitText(elem, fitTextProps){
		if(!elem.dataset.langFitText)
			return;
	
		onFitText(elem, fitTextProps);
		setTimeout(() => onFitText(elem, fitTextProps), 0);
	}
	
	function onFitText(elem, fitTextProps){
		var span = elem.querySelector('.shown');
		var dim = checkIfTextOutOfBounce(fitTextProps.parent || elem);
		var percDiff = dim.parentWidth / dim.spanWidth;
		var currFontSize = Number(getComputedStyle(elem).fontSize.replace(/[^0-9.]/g, ''));
		var newFontSize = Math.floor(currFontSize * percDiff); //floor fixes a resizing issue when scrolling up and down on iOS
		if(newFontSize > fitTextProps.maxSize)
			newFontSize = fitTextProps.maxSize;
		span.style.fontSize = `${newFontSize}px`;
	}
	
	function checkIfTextOutOfBounce(parent){
		var span = parent.querySelector('span:not(.shown)');
		var spanWidth = span.offsetWidth;
		var style = getComputedStyle(parent);
		var paddingLeft = parseFloat(style.paddingLeft);
		var paddingRight = parseFloat(style.paddingRight);
		var borderLeft = parseFloat(style.borderLeftWidth);
		var borderRight = parseFloat(style.borderRightWidth);
		return {
			spanWidth: spanWidth,
			parentWidth: parent.offsetWidth - paddingLeft - paddingRight - borderLeft - borderRight,
		};
	}
	
	model.vue.app.directive('lang', {
		beforeMount,
		updated,
		unmounted(element){
			element.langDisposeCallback?.();
		}
	});
}